module.exports = __webpack_public_path__ + "static/media/faq2.bff0a7d4.webp";